/** El `kind` de los planes viejos que mezclaba duración y alcance. Sólo lo lee este shim. */
export const LEGACY_REFORMER_ONLY_KIND = "reformer_only";
/**
 * Los `kind` que en la base valen como «mensual» (débito automático, RN-PLA-24): el
 * mensual de cualquier perfil más el Solo Reformer viejo. Para filtros de Mongo sobre
 * `planSnapshot.kind`.
 */
export const MONTHLY_KINDS_IN_DB = ["monthly", LEGACY_REFORMER_ONLY_KIND];
/** El alcance efectivo de un plan, con el shim de `reformer_only` aplicado. */
export function resolvePlanAccess(plan) {
    const ids = (list) => (list ?? []).map((id) => String(id));
    if (plan.kind === LEGACY_REFORMER_ONLY_KIND) {
        // RN-PLA-02: el pase Solo Reformer viejo guardaba Reformer en sus inclusiones.
        const allowed = ids(plan.allowedDisciplineIds);
        return {
            kind: "monthly",
            accessProfile: "disciplines_only",
            allowedDisciplineIds: allowed.length > 0
                ? allowed
                : ids((plan.weeklyInclusions ?? []).map((inclusion) => inclusion.disciplineId)),
        };
    }
    const accessProfile = plan.accessProfile === "disciplines_only" || plan.accessProfile === "strength_only"
        ? plan.accessProfile
        : "full";
    return {
        kind: plan.kind,
        accessProfile,
        allowedDisciplineIds: accessProfile === "disciplines_only" ? ids(plan.allowedDisciplineIds) : [],
    };
}
//# sourceMappingURL=plan-access.js.map